import { DEFAULT_ASPECT_RATIO, detectAspectRatio, type AspectRatio } from '@paint-ai/shared';
import { useEffect, useState } from 'react';
import { loadImage } from '@/lib/image';

/** Output aspect ratio matching the selected photo's framing (what the render request will use). */
export function useImageAspectRatio(src: string | null): AspectRatio {
  const [aspectRatio, setAspectRatio] = useState<AspectRatio>(DEFAULT_ASPECT_RATIO);

  useEffect(() => {
    if (!src) return;
    let cancelled = false;
    loadImage(src)
      .then((img) => !cancelled && setAspectRatio(detectAspectRatio(img.naturalWidth, img.naturalHeight)))
      .catch(() => !cancelled && setAspectRatio(DEFAULT_ASPECT_RATIO));
    return () => {
      cancelled = true;
    };
  }, [src]);

  return aspectRatio;
}
